// extracted by mini-css-extract-plugin
export default {"wrapper":"_d945f37d","header":"_85276cf1","learnMore":"_8796f","benefits":"_876e2e4a","benefitColumn":"_67d647cf"};